import { ChangeDetectionStrategy, Component, computed, inject, model, ModelSignal } from '@angular/core';
import { IMemberContractStatus, MemberContractStatusEnum } from '@vierkant-software/types__api';
import { DateTime } from 'luxon';
import { CommonModule } from '@angular/common';
import { VComponentsModule } from '../../modules/wrappers';
import { SharedModule } from '../../shared.module';
import { GcLayoutModule } from '../v-layout/layout.module';
import { VDateModule } from '../v-date/v-date.module';
import { Globals } from '../../services/globals.service';

@Component({
  selector:        'app-member-contract-chip',
  templateUrl:     './member-contract-chip.component.haml',
  styleUrls:       ['./member-contract-chip.component.sass'],
  standalone:      true,
  imports:         [CommonModule, SharedModule, GcLayoutModule, VDateModule, VComponentsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MemberContractChipComponent {
  status: ModelSignal<IMemberContractStatus> = model(null);

  private today = DateTime.now().startOf('day');
  private endDate = computed(() => this.status()?.end?.startOf('day') || null);

	public readonly globals = inject(Globals);

  chipColor = computed(() => {
    const status = this.status();
    if (!status) return '';
    const endDate = this.endDate();
    if (status.status === MemberContractStatusEnum.active && !endDate) return 'Success';
    if (status.status === MemberContractStatusEnum.active && endDate && this.today < endDate) return 'Warning';
    if ([MemberContractStatusEnum.canceled, MemberContractStatusEnum.withdrawal, MemberContractStatusEnum.terminated].includes(status.status)) return 'Danger';
    if ([MemberContractStatusEnum.ended, MemberContractStatusEnum.notBooked].includes(status.status)) return 'Secondary';
    return '';
  });

  isBeginningBeforeToday = computed(() => this.status()?.begin && this.today < this.status()!.begin.startOf('day'));
  isActiveAndEndingInTheFuture = computed(() => this.status()?.status === MemberContractStatusEnum.active && this.today < this.endDate()!);
  isTerminatedAndEndingInTheFuture = computed(() => this.status()?.status === MemberContractStatusEnum.terminated && this.today < this.endDate()!);
  isEndingInTheFuture = computed(() => this.today < this.endDate()!);
}
